import {ACTIONS} from "../reducers/charactersReducer";

import webToolApi from "../../helpers/webToolApiHelper";

import {defaultErrorAction} from "./errorsActions";
import {notifyResponseError} from "./notificationsActions";

export function changeCharactersLoading(isLoading) {
  return {type: ACTIONS.CHANGE_CHARACTERS_LOADING, isLoading};
}

export function fetchCharacters() {
  return (dispatch) => {
    dispatch(changeCharactersLoading(true));
    dispatch({type: ACTIONS.FETCH_CHARACTERS});

    webToolApi().get(Routes.characters_path())
      .then((response) => {
        dispatch({type: ACTIONS.FETCH_CHARACTERS_FULFILLED, payload: response.data});
      })
      .catch(({response}) => {
        dispatch(defaultErrorAction(ACTIONS.FETCH_CHARACTERS_REJECTED, response));
        dispatch(notifyResponseError(I18n.t("user_scenarios.messages.index.error"), response));
      })
      .finally(() => {
        dispatch(changeCharactersLoading(false));
      });
  }
}
